export abstract class ChannelInfo {
  value!: string
  status!: boolean
}

export class ErrorChannelInfo extends ChannelInfo {
  declare status: false
  error!: string
}

export class SuccessChannelInfo extends ChannelInfo{
  declare status: true
  info!: {
    id: number
    login?: string
    title: string
    type: string
  }
}
